import { ASSET } from '../configs/constants';
import axios from '../../../configs/axios';

const {
  countries,
  publisher,
  sdks,
  time_series,
  top_apps,
} = ASSET;

// Publisher Assets
export const makePubAssetList = permissions => [
  countries,
  ...(permissions.allowAppLevelSdk ? [sdks] : []),
  time_series,
  top_apps,
  publisher,
];

export const fetchPubQuickview = (requestParams, cancelToken) => (
  axios.get('/prospector/publisher_data', { params: requestParams, cancelToken }));

export const pushPublisherToSalesforce = requestParams => axios.post('/prospector/push_to_salesforce', requestParams);
